const Advertistment = (props) => {

    return (
        <div className="advertistment">This space in {props.chatroom} avalabel for advitersing<br /> Call 0112142559 for more info</div>
    );
};

export default Advertistment;